export const isNotEmpty = (val: any): boolean => {
    if (!val) return false;
    const isValid = val.trim() == "" ? false : true;
    return isValid;
};

export const lengthIsLessThan = (val: any, maxLength: number): boolean => {
    if (!val) return true;
    const isValid = val.trim().length <= maxLength ? true : false;
    return isValid;
};

export const lengthIsBetween = (val: any, maxLength: number): boolean => {
    if (!val) return true;
    let isValid = false;
    if (val.trim().length >= 1 && val.trim().length <= maxLength) {
        isValid = true;
    }
    return isValid;
};

export const numberIsBetween = (val: any, maxLength: number): boolean => {
    if (!val) return true;
    let isValid = false;
    let valNum = parseInt(val);
    if (valNum >= 1 && valNum <= maxLength) {
        isValid = true;
    }
    return isValid;
};

export const numberIsLessThanMax = (val: any, maxLength: number): boolean => {
    if (!val) return true;
    let isValid = false;
    let valNum = parseInt(val);
    if (valNum >= 0 && valNum <= maxLength) {
        isValid = true;
    }
    return isValid;
};

export const lengthIsLessThanAndIsNotEmpty = (val: any, maxLength: number): boolean => {
    if (!val) return false;
    let isValid = isNotEmpty(val);
    if (isValid) isValid = val.trim().length <= maxLength ? true : false;
    return isValid;
};
